module.exports = __webpack_public_path__ + "img/no_driver.8dd6d60c.png";